import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams, useNavigate } from 'react-router-dom';
import { useStores } from "../../../stores/store";
import { useTranslation } from "react-i18next";
import Loader from "../../common/loader";

export default function AdminSchoolActivationCodeEditPage() {
    const { t } = useTranslation();
    const { auth } = useStores();
    const { id } = useParams();
    let navigate = useNavigate();

    const [isDataError, setIsDataError] = useState(false);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [code, setCode] = useState(null);

    const { register, setValue, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = data => postData(data);

    useEffect(() => {
        if (id !== "new") {
            setIsDataLoading(true);
            setIsDataError(false);

            auth.getSchoolActivationCode(id).then((res) => {
                setCode(res.data);
                setIsDataLoading(false);
            }).catch((error) => {
                setIsDataLoading(false);
                setIsDataError(true);
            });
        } else {
            setIsDataLoading(false);
        }
    }, [])

    useEffect(() => {
        if (code) {
            setValue('code', code?.code)
            setValue('production_lot', code?.production_lot)
            setValue('notes', code?.notes)
            setValue('commercial_agent', code?.commercial_agent)
            setValue('suspended', code?.suspended)
        }
    }, [code]);

    const postData = (data) => {
        if (id !== "new") {
            auth.editSchoolActivationCode(id, data).then(() => {
                navigate(`/admin/school-activation-codes/`);
            });
        } else {
            auth.addSchoolActivationCode(data).then(() => {
                navigate(`/admin/school-activation-codes/`);
            });
        }
    }

    if (isDataLoading)
        return <div className='grid h-screen place-items-center'><Loader /></div>

    if (isDataError)
        return <div className='grid h-screen place-items-center'>{t('cannotLoadPage')}</div>

    return (
        <div className="w-full flex flex-col">
            <div className="flex flex-row justify-center">
                <span className="text-4xl">{id === "new" ? t('new') : t('edit')}</span>
            </div>

            <div className="w-full flex flex-row justify-center mt-6">
                <div className="w-1/3 bg-white">
                    <form className="w-full bg-white flex flex-col gap-4 p-8 rounded-3xl shadow-xl" onSubmit={handleSubmit(onSubmit)}>

                        {id !== "new" && (
                            <div className="flex flex-col">
                                <label className="block text-gray-700 text-sm font-bold mb-2">{t('code')}</label>
                                <input disabled className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-400 bg-gray-100 leading-tight" {...register("code")} />
                            </div>
                        )}

                        <div className="flex flex-col">
                            <label className="block text-gray-700 text-sm font-bold mb-2">{t('productionLot')}</label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" {...register("production_lot")} />
                        </div>

                        <div className="flex flex-col">
                            <label className="block text-gray-700 text-sm font-bold mb-2">{t('note')}</label>
                            <textarea rows={5} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" {...register("notes")}></textarea>
                        </div>

                        <div className="flex flex-col">
                            <label className="block text-gray-700 text-sm font-bold mb-2">{t('agent')}</label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" {...register("commercial_agent")} />
                        </div>

                        <div className="flex flex-row items-center gap-2">
                            <input type="checkbox" {...register("suspended")} />
                            <label className="block text-gray-700 text-sm font-bold">{t('suspended')}</label>
                        </div>

                        <button className="bg-primary hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full mt-4" type="submit">{t('save')}</button>
                        <button className="border-2 border-primary text-primary font-bold py-2 px-4 rounded-full" onClick={(e) => { e.preventDefault(); navigate('/admin/school-activation-codes') }}>{t('cancel')}</button>
                    </form>
                </div>
            </div>
        </div>
    );
}
